import React from "react";

const PlanogramDisplay = ({
  planogram,
  numberOfProductsOnShelf = {},
  numberOfProductsOnPlanogram = {},
  productsCount = {},
  alerts = [],
}) => {
  if (!planogram || !planogram.product) {
    return (
      <div className="text-center text-gray-500 p-4">
        No planogram data available
      </div>
    );
  }

  const bgColor = alerts.some((item) => item.productId === planogram.productId)
    ? "bg-red-500"
    : "bg-white";

  return (
    <div className="flex flex-wrap gap-4">
      <div
        key={planogram?.productId}
        className={`flex flex-col border rounded-lg shadow p-4 ${bgColor}`}
      >
        <div className="flex items-start">
          <img
            src={planogram.product.imageUrl || ""}
            alt={planogram.product.name || "Product"}
            className="w-20 h-20 mr-4 object-cover"
          />
        </div>
        <p className="text-l font-black text-center">
          {numberOfProductsOnShelf[planogram.productId] ?? 0}/
          {numberOfProductsOnPlanogram[planogram.productId] ?? 0}
        </p>
        <p className="text-xl font-black text-center">
          {productsCount[planogram.productId] ?? 0}
        </p>
      </div>
    </div>
  );
};

export default PlanogramDisplay;
